// Returns the HTTP status of a stored error response (e.g. `userReducer.error`), if it has a numeric one
export const getErrorStatus = (error: unknown): number | undefined => (
    error instanceof Object && 'status' in error && typeof error.status === 'number' ? error.status : undefined
)
